import moment from 'moment-timezone';
import { Lilate } from '../model/lilate.model';
import { parisToday, toParisDay } from './paris-day.util';

/**
 * Date de passage d'un LILATE (SUP-2361).
 *
 * Engage calcule `exam_date` (Lilate.exam_date), la date imprimée sur le certificat
 * et les attestations : fin réelle du test en IA, créneau en examinateur. En IA,
 * `start` est posé à la génération du test (statut « Prêt »), parfois des jours
 * avant le passage : il ne doit pas être affiché comme date de passage.
 */

type LilateExamDateSource = Pick<Lilate, 'exam_date' | 'start'>;

/** Date de passage ; `start` seulement si la réponse de l'API ne porte pas `exam_date`. */
export function lilateExamDate(lilate: LilateExamDateSource | null | undefined): Date | string | null {
    return lilate?.exam_date ?? lilate?.start ?? null;
}

/**
 * True si le délai d'accès aux résultats est écoulé : jour de passage à Paris
 * + `minimum_access_time` jours, comme can_access_results() côté Engage.
 */
export function isLilateAccessDelayElapsed(
    lilate: (LilateExamDateSource & Pick<Lilate, 'minimum_access_time'>) | null | undefined,
    now: Date | moment.Moment = new Date(),
): boolean {
    const examDay = toParisDay(lilateExamDate(lilate));
    if (!examDay) {
        return false;
    }
    const openingDay = moment(examDay, 'YYYY-MM-DD')
        .add(lilate?.minimum_access_time || 0, 'days')
        .format('YYYY-MM-DD');
    return openingDay <= parisToday(now);
}
